/* eslint-disable react/no-danger */
import ModalContainer from 'components/ModalContainer'
import { ZENDESK_URL } from 'config'
import { HelpIcon } from 'assets/icons'

const TermsModal = ({ content, isOpen, setIsOpen }) => (
  <ModalContainer
    isShown={isOpen}
    setModalFunction={setIsOpen}
    className='pb-12 md:min-w-[40rem]'
    title='Términos y condiciones'
  >
    <div
      className='text-black pt-2 pr-4 text-xs max-h-96 overflow-y-scroll'
      dangerouslySetInnerHTML={{ __html: content }}
    />
    <a
      className='flex justify-center items-center py-[10px] hover:underline hover:underline-offset-1'
      href={ZENDESK_URL}
      target='_blank'
      rel='noreferrer'
    >
      <HelpIcon />
      <p className='ml-1 text-[14px] text-purple-900 font-bold'>Ayuda</p>
    </a>
  </ModalContainer>
)

export default TermsModal
